import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_PM_SCHEDULE_VARIANCE_API } from "./apiRoutes";

interface Props {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getScheduleVariance = async (projectId: string) => {
  return await axiosAuth.get(`${DASHBOARD_PM_SCHEDULE_VARIANCE_API(projectId)}`);
};

const useGetPmScheduleVariance = ({ projectId, queryParams }: Props): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-schedule-variance", projectId],
    queryFn: () => getScheduleVariance(projectId),
    select: (data: any) => data.data.data,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
    ...queryParams,
  });
};

export default useGetPmScheduleVariance;
